import { render, staticRenderFns } from "./FamilyEngagementCore.vue?vue&type=template&id=56093c20&scoped=true"
import script from "./FamilyEngagementCore.ts?vue&type=script&lang=ts&external"
export * from "./FamilyEngagementCore.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56093c20",
  null
  
)

export default component.exports